import DominanceChart from "./DominanceChart.svelte";
import './index.css'

const getLanguageCodeFromUrl = () => {
  const languageCodePathSection = new URL(document.URL).pathname.slice(1).split('/')[0];
  return languageCodePathSection.length == 2 ? languageCodePathSection : "en";
}

const app = new DominanceChart({
  target: document.getElementsByClassName('dominance-chart')[0],
  props: {
    language: getLanguageCodeFromUrl()
  }
});

export default app;
